<template>
  <router-view />
</template>

<script>
export default {
  name: 'Driver'
}
</script>
